import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CurrentApiService, ProjectService, ElementsService, IElement } from 'dbweb-core';
import { MatSnackBar } from '@angular/material';
const MUST = 'MUST';

interface ImportField {
	Name: string;
	Alias: string;
	Type: string;
	MaxLength: number;
	Style: string;
	PrimaryKey: boolean;
	Remark: string;
}
interface MapField {
	Name: string;
	Style: string;
	MapName: string;
	Value: string;
	Remark: string;
}
interface RefreshPreviewParam {
	FileName: string;
	Format: string;
	Encoding: string;
	FirstHead: boolean;
}
interface RefreshPreviewResult {
	Title: string[];
	Rows: string[][];
	Error: string;
}
interface DoImportParam {
	FileName: string;
	FirstHead: boolean;
	Encoding: string;
	Format: string;
	Fields: {
		Name: string;
		MapName: string;
		Value: string;
	}[];
}
export interface DoImportResult {
	TaskInfoURL: string;
	TaskInfoSign: string;
	BrowseTaskElement: IElement;
}
export interface ImportInfo {
	TableName: string;
	TableTotal: number;
	TableCanRemove: number;
	Fields: ImportField[];
	NullIden: string;
}
export interface RemoveTableDataResult {
	Total: number;
	CanRemove: number;
}
@Injectable()
export class ImportService {
	step: 'select-file' | 'upload' | 'setting' | 'done' = 'select-file';
	tableName: string;
	tableTotal: number;
	tableCanRemove: number;
	fields: ImportField[];
	file: File;
	uploadProgress: number;
	serverTempFileName: string; // æå¡ç«¯å¯ä¸çä¸´æ¶æä»¶å

	firstHead = true; // æ¯å¦æ¯é¦è¡çæ è¯
	format: 'CSV' | 'TXT' = 'CSV';
	encoding: 'UTF8' | 'GBK' = 'UTF8';
	nullIden: string;
	previewData: {
		Have: boolean;
		Title: string[];
		Rows: string[][];
		Error: string;
	} = { Have: false, Title: null, Rows: null, Error: '' };
	mapFields: MapField[];

	taskInfoURL: string;

	constructor(
		private api: CurrentApiService,
		private prj: ProjectService,
		private eles: ElementsService,
		private snackBar: MatSnackBar
	) {}
	init() {
		this.GetImportInfo().subscribe(v => {
			this.tableName = v.TableName;
			this.tableTotal = v.TableTotal;
			this.tableCanRemove = v.TableCanRemove;
			this.fields = v.Fields;
			this.nullIden = v.NullIden;
			this.mapFields = v.Fields.map(fld => ({
				Name: fld.Name,
				Style: fld.Style,
				MapName: '',
				Value: '',
				Remark: fld.Remark
			}));
		});
	}
	GetImportInfo() {
		return this.api.get<ImportInfo>('get-import-info');
	}
	mustFields() {
		if (this.fields) {
			return this.fields.filter(v => v.Style === MUST).map(v => v.Name);
		} else {
			return [];
		}
	}
	primaryKeyFields() {
		if (this.fields) {
			return this.fields.filter(v => v.PrimaryKey).map(v => v.Name);
		} else {
			return [];
		}
	}
	fileType() {
		if (this.file) {
			const list = this.file.name.split('.');
			if (list.length > 1) {
				return '.' + list[1];
			}
		}
		return '';
	}
	// ä¸ä¼ æä»¶ä½¿ç¨äºè¿åçè·¯ç±ï¼æä»¥éè¦èªå·±è°ç¨åççhttpè¯·æ±
	upload() {
		let sentBegin: NodeJS.Timeout;
		this.api.upload<string>(this.file, 'content', 'upload-import-file').subscribe(event => {
			switch (event.type) {
				case HttpEventType.Sent:
					// å°äº500æ¯«ç§çä¸ä¼ ï¼ä¸æ¾ç¤ºä¸­é´çä¸ä¼ è¿åº¦çé¢ï¼é²æ­¢çé¢éªç
					sentBegin = setTimeout(() => {
						this.step = 'upload';
						sentBegin = null;
					}, 500);
					break;
				case HttpEventType.UploadProgress:
					this.uploadProgress = Math.round(event.loaded / event.total * 100);
					break;
				case HttpEventType.Response:
					if (sentBegin) {
						clearTimeout(sentBegin);
						sentBegin = null;
					}
					this.step = 'setting';
					this.serverTempFileName = event.body;
					this.previewData.Error = '';
					this.previewData.Have = false;
					break;
				default:
					console.log(event);
					break;
			}
		});
	}
	refreshPreview() {
		this.api
			.post<RefreshPreviewResult>('refresh-preview', {
				FileName: this.serverTempFileName,
				Format: this.format,
				Encoding: this.encoding,
				FirstHead: this.firstHead
			} as RefreshPreviewParam)
			.subscribe(rev => {
				this.previewData.Have = true;
				this.previewData.Title = rev.Title;
				this.previewData.Rows = rev.Rows;
				this.previewData.Error = rev.Error;
				this.mapFields.forEach((v, index) => {
					if (this.firstHead) {
						v.MapName = this.previewData.Title.find(str => str.toLowerCase() === v.Name.toLowerCase());
						if (!v.MapName) {
							// æ ¹æ®å«ååæ¾ä¸é
							const alias = this.fields.find(afield => afield.Name === v.Name).Alias;
							v.MapName = this.previewData.Title.find(str => str.toLowerCase() === alias.toLowerCase());
						}
					} else {
						v.MapName = this.previewData.Title[index];
					}
					if (v.MapName === undefined) {
						v.MapName = '(SKIP)';
					}
				});
				console.log('------', this.previewData.Have || this.previewData.Error);
			});
	}
	doImport() {
		this.api
			.post<DoImportResult>('do-import', {
				FileName: this.serverTempFileName,
				FirstHead: this.firstHead,
				Encoding: this.encoding,
				Format: this.format,
				Fields: this.mapFields.map(v => ({
					Name: v.Name,
					MapName: v.MapName,
					Value: v.Value
				})),
				NullIden: this.nullIden
			} as DoImportParam)
			.subscribe(v => {
				this.step = 'done';
				this.taskInfoURL = this.prj.frontURL('task', v.TaskInfoURL);
				this.eles.addElement(v.BrowseTaskElement);
				this.eles.setURLSign(v.TaskInfoURL, v.TaskInfoSign);
			});
	}
	removeTableData() {
		this.api.post<RemoveTableDataResult>('remove-table-data').subscribe(v => {
			this.tableTotal = v.Total;
			this.tableCanRemove = v.CanRemove;
			this.snackBar.open('æåå é¤æ°æ®', 'å³é­', { duration: 5000 });
		});
	}
}
